import { GoogleLogin } from '@react-oauth/google';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Link from 'next/link';
import { useState } from 'react';
import Header from '../components/Header';

export default function Register() {
    const router = useRouter();
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const res = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/google`, {
                credential: credentialResponse.credential,
                client_id: credentialResponse.clientId,
            });

            dispatch({ type: 'SET_USER', payload: res.data.user });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('user', JSON.stringify(res.data.user));

            router.push('/');
        } catch (error) {
            setError(error.response?.data?.message || 'Google registration failed');
        }
    };

    const handleEmailRegister = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/register`, { name, email, password });
            dispatch({ type: 'SET_USER', payload: res.data.user });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('user', JSON.stringify(res.data.user));
            router.push('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Registration failed');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            <Header />
            <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="w-full max-w-md space-y-8 bg-white p-10 rounded-2xl shadow-xl border border-gray-100">
                    <div className="text-center">
                        <h2 className="text-3xl font-extrabold text-gray-900">Create Account</h2>
                        <p className="mt-2 text-sm text-gray-600">Start your journey with Easytravel</p>
                    </div>

                    {error && (
                        <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm text-center border border-red-100">
                            {error}
                        </div>
                    )}

                    <form className="mt-8 space-y-5" onSubmit={handleEmailRegister}>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Full Name</label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border-2 border-gray-100 focus:border-green-500 rounded-xl px-4 py-3 text-sm transition-all outline-none"
                                    placeholder="John Doe"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Email Address</label>
                                <input
                                    type="email"
                                    required
                                    className="w-full border-2 border-gray-100 focus:border-green-500 rounded-xl px-4 py-3 text-sm transition-all outline-none"
                                    placeholder="your@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Password</label>
                                <input
                                    type="password"
                                    required
                                    className="w-full border-2 border-gray-100 focus:border-green-500 rounded-xl px-4 py-3 text-sm transition-all outline-none"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl transition-all shadow-lg shadow-green-600/20"
                        >
                            Sign Up
                        </button>
                    </form>

                    <div className="relative my-8">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-200"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-white text-gray-500 uppercase tracking-wider text-xs font-bold">Or register with</span>
                        </div>
                    </div>

                    <div className="flex justify-center">
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={() => setError('Google registration failed')}
                            useOneTap
                        />
                    </div>

                    <p className="mt-8 text-center text-sm text-gray-600">
                        Already have an account? <Link href="/login" className="font-bold text-green-600 hover:text-green-700 transition-colors">Login here</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
